/** Common */
export const GET_USER_ENTITLEMENTS = 'GET_USER_ENTITLEMENTS';
export const GET_USER_ENTITLEMENTS_SUCCESS = 'GET_USER_ENTITLEMENTS_SUCCESS';

/** User Data */
export const GET_BILLING_INFORMATION_SUCCESS = 'GET_BILLING_INFORMATION_SUCCESS';
export const RESET_BILLING_INFO = 'RESET_BILLING_INFO';
export const GET_BILLING_INFORMATION_ERROR = 'GET_BILLING_INFORMATION_ERROR';
export const GET_BILLING_INFORMATION_LOADING = 'GET_BILLING_INFORMATION_LOADING';
// #genai Phase 2 — targeted merge of billPayerId onto userData.billingInformation without
// touching the rest of the /bill-payer-info payload (address, billingType, creditCard, ...).
// Used only by the Add-ACH / Add-Card deep-link hydration in loadBillingAccountContextSaga to
// avoid populating billingInformation.achInfo (which would flip AchPaymentInformation into
// summary mode and pre-fill the "fresh form").
export const SET_USER_DATA_BILL_PAYER_ID = 'SET_USER_DATA_BILL_PAYER_ID';
export const ORDER_PREFERENCES_SUCCESS = 'ORDER_PREFERENCES_SUCCESS';
export const ORDER_PREFERENCES_LOADING = 'ORDER_PREFERENCES_LOADING';
export const ORDER_PREFERENCES_ERROR = 'ORDER_PREFERENCES_ERROR';
export const CONTROL_STATES_SUCCESS = 'CONTROL_STATES_SUCCESS';
export const CONTROL_STATES_LOADING = 'CONTROL_STATES_LOADING';
export const CONTROL_STATES_ERROR = 'CONTROL_STATES_ERROR';
export const LOAD_COMPANY_INFO = 'LOAD_COMPANY_INFO';
export const COMPANY_INFO_LOADING = 'COMPANY_INFO_LOADING';
export const COMPANY_INFO_DETAILS = 'COMPANY_INFO_DETAILS';
export const COMPANY_INFO_SUCCESS = 'COMPANY_INFO_SUCCESS';
export const COMPANY_INFO_ERROR = 'COMPANY_INFO_ERROR';
export const GET_CONTACT_INFORMATION_SUCCESS = 'GET_CONTACT_INFORMATION_SUCCESS';
export const GET_CONTACT_INFORMATION_ERROR = 'GET_CONTACT_INFORMATION_ERROR';
export const GET_CONTACT_INFORMATION_LOADING = 'GET_CONTACT_INFORMATION_LOADING';
export const GET_CONTACT_INFO_LOAD_COMPANY_LOGO = 'GET_CONTACT_INFO_LOAD_COMPANY_LOGO';
export const LOAD_USER_PRODUCTS = 'LOAD_USER_PRODUCTS';
export const LOAD_PRODUCT_CATALOG = 'LOAD_PRODUCT_CATALOG'; // #genai
export const PRODUCT_CATALOG_LOADING = 'PRODUCT_CATALOG_LOADING'; // #genai
export const PRODUCT_CATALOG_SUCCESS = 'PRODUCT_CATALOG_SUCCESS'; // #genai
export const PRODUCT_CATALOG_ERROR = 'PRODUCT_CATALOG_ERROR'; // #genai
export const ORG_DESCENDANTS_LOADING = 'ORG_DESCENDANTS_LOADING';
export const ORG_DESCENDANTS_SUCCESS = 'ORG_DESCENDANTS_SUCCESS';
export const ORG_DESCENDANTS_ERROR = 'ORG_DESCENDANTS_ERROR';
export const GET_ORG_DESCENDANTS = 'GET_ORG_DESCENDANTS';
export const GET_USER_ENTITLED_APPS = 'GET_USER_ENTITLED_APPS';
export const USER_ENTITLED_APPS_LOADING = 'USER_ENTITLED_APPS_LOADING';
export const USER_ENTITLED_APPS_SUCCESS = 'USER_ENTITLED_APPS_SUCCESS';
export const USER_ENTITLED_APPS_ERROR = 'USER_ENTITLED_APPS_ERROR';
export const GET_ENTITLED_THIRDPARTY_APPS = 'GET_ENTITLED_THIRDPARTY_APPS'; // #genai
export const ENTITLED_THIRDPARTY_APPS_LOADING = 'ENTITLED_THIRDPARTY_APPS_LOADING'; // #genai
export const ENTITLED_THIRDPARTY_APPS_SUCCESS = 'ENTITLED_THIRDPARTY_APPS_SUCCESS'; // #genai
export const ENTITLED_THIRDPARTY_APPS_ERROR = 'ENTITLED_THIRDPARTY_APPS_ERROR'; // #genai
export const LOADING_SUBSCRIPTION_DASHBOARD = 'LOADING_SUBSCRIPTION_DASHBOARD';
export const SUBSCRIPTION_DASHBOARD_SUCCESS = 'SUBSCRIPTION_DASHBOARD_SUCCESS';
export const SUBSCRIPTION_DASHBOARD_ERROR = 'SUBSCRIPTION_DASHBOARD_ERROR';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const USER_PROFILE_LOADING = 'USER_PROFILE_LOADING';
export const USER_PROFILE_SUCCESS = 'USER_PROFILE_SUCCESS';
export const USER_PROFILE_ERROR = 'USER_PROFILE_ERROR';

/** Order Page */
export const SET_SHOW_MAP = 'SET_SHOW_MAP';
export const SET_USE_EMBEDDED_EXPLORER = 'SET_USE_EMBEDDED_EXPLORER';
export const GEOCODE_SUCCESS = 'GEOCODE_SUCCESS';
export const GEOCODE_ERROR = 'GEOCODE_ERROR';
export const SET_COUNTRY = 'SET_COUNTRY';
export const FETCH_ADDRESS = 'FETCH_ADDRESS';
export const OPEN_MAP_TOAST = 'OPEN_MAP_TOAST';
export const CLOSE_MAP_TOAST = 'CLOSE_MAP_TOAST';
export const CLOSE_DUPLICATE_DIALOG = 'CLOSE_DUPLICATE_DIALOG';
export const GET_DUPLICATE_REPORTS = 'GET_DUPLICATE_REPORTS';
export const ORDER_PAGE_DUPLICATE_REPORTS_SUCCESS = 'ORDER_PAGE_DUPLICATE_REPORTS_SUCCESS';
export const ORDER_PAGE_DUPLICATE_REPORTS_ERROR = 'ORDER_PAGE_DUPLICATE_REPORTS_ERROR';
export const SET_PROPERTY_TYPE = 'SET_PROPERTY_TYPE';
export const SET_IS_COMPLEX = 'SET_IS_COMPLEX';
export const UPDATE_MAP_POINT_ADDRESS = 'UPDATE_MAP_POINT_ADDRESS';
export const UPDATE_MAP_POINT_ADDRESS_ACTION = 'UPDATE_MAP_POINT_ADDRESS_ACTION';
export const LOAD_ORDER_PAGE = 'LOAD_ORDER_PAGE';
export const USER_PRODUCTS_SUCCESS = 'USER_PRODUCTS_SUCCESS';
export const USER_PRODUCTS_ERROR = 'USER_PRODUCTS_ERROR';
export const GET_INIT_PARAMETERS = 'GET_INIT_PARAMETERS';
export const INIT_PARAMETERS_SUCCESS = 'INIT_PARAMETERS_SUCCESS';
export const INIT_PARAMETERS_ERROR = 'INIT_PARAMETERS_ERROR';
export const SET_SELECTED_PRODUCT = 'SET_SELECTED_PRODUCT';
export const UPDATE_SELECTED_PRODUCT = 'UPDATE_SELECTED_PRODUCT';
export const SET_SELECTED_OTHER_PRODUCTS = 'SET_SELECTED_OTHER_PRODUCTS';
export const ADD_MAP_POINT = 'ADD_MAP_POINT';
export const ADD_MAP_PIN = 'ADD_MAP_PIN';
export const DELETE_MAP_POINT = 'DELETE_MAP_POINT';
export const DELETE_MAP_POINT_ACTION = 'DELETE_MAP_POINT_ACTION';
export const UPDATE_MAP_POINT_LOCATION = 'UPDATE_MAP_POINT_LOCATION';
export const UPDATE_MAP_POINT_LOCATION_ACTION = 'UPDATE_MAP_POINT_LOCATION_ACTION';
export const UPDATE_FOCUSED_POINT = 'UPDATE_FOCUSED_POINT';
export const UPDATE_ADDRESS_SEARCH_TEXT = 'UPDATE_ADDRESS_SEARCH_TEXT';
export const SET_SELECTED_MEASUREMENT_REQUEST = 'SET_SELECTED_MEASUREMENT_REQUEST';
export const SET_PRODUCT_LOADING = 'SET_PRODUCT_LOADING';
export const SOLAR_PRODUCTS_AVAILABILITY_SUCCESS = 'SOLAR_PRODUCTS_AVAILABILITY_SUCCESS';
export const GET_SOLAR_PRODUCTS_AVAILABILITY = 'GET_SOLAR_PRODUCTS_AVAILABILITY';
export const SOLAR_PRODUCTS_AVAILABILITY_ERROR = 'SOLAR_PRODUCTS_AVAILABILITY_ERROR';
export const OPEN_VALIDATION_MESSAGE_DIALOG = 'OPEN_VALIDATION_MESSAGE_DIALOG';
export const CLOSE_VALIDATION_MESSAGE_DIALOG = 'CLOSE_VALIDATION_MESSAGE_DIALOG';
export const ORDER_RESET_ERROR = 'ORDER_RESET_ERROR';
export const INIT_PARAMETERS_LOADING = 'INIT_PARAMETERS_LOADING';
export const USER_PRODUCTS_LOADING = 'USER_PRODUCTS_LOADING';
export const ADD_UPGRADE_MAP_POINTS = 'ADD_UPGRADE_MAP_POINTS';
export const ADD_UPGRADE_PRODUCT_SETS = 'ADD_UPGRADE_PRODUCT_SETS';
export const RESET_EDIT_ORDER = 'RESET_EDIT_ORDER';
export const SET_FEATURE_FLAG = 'SET_FEATURE_FLAG';
export const FETCH_PIN_ADDRESS = 'FETCH_PIN_ADDRESS';

/** Order Page - Panel Management */
export const SET_PANEL_TYPE = 'SET_PANEL_TYPE';
export const PROPERTY_DATA_REQUEST = 'PROPERTY_DATA_REQUEST';
export const PROPERTY_DATA_REQUEST_LOADING = 'PROPERTY_DATA_REQUEST_LOADING';
export const PROPERTY_DATA_REQUEST_SUCCESS = 'PROPERTY_DATA_REQUEST_SUCCESS';
export const PROPERTY_DATA_REQUEST_ERROR = 'PROPERTY_DATA_REQUEST_ERROR';
export const PROPERTY_DATA_RESULT = 'PROPERTY_DATA_RESULT';
export const PROPERTY_DATA_RESULT_LOADING = 'PROPERTY_DATA_RESULT_LOADING';
export const PROPERTY_DATA_RESULT_SUCCESS = 'PROPERTY_DATA_RESULT_SUCCESS';
export const PROPERTY_DATA_RESULT_ERROR = 'PROPERTY_DATA_RESULT_ERROR';

/** Order Page - Blueprint */
export const ORDER_PAGE_UPLOAD_BLUEPRINT_FILE = 'ORDER_PAGE_UPLOAD_BLUEPRINT_FILE';
export const ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS = 'ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_SUCCESS';
export const ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_ERROR = 'ORDER_PAGE_UPLOAD_BLUEPRINT_FILE_ERROR';
export const ORDER_PAGE_UPDATE_BLUEPRINT_ID = 'ORDER_PAGE_UPDATE_BLUEPRINT_ID';
export const ORDER_PAGE_UPLOADING_BLUEPRINT_FILE = 'ORDER_PAGE_UPLOADING_BLUEPRINT_FILE';
export const PRIMARY_SUBSCRIPTION_PRODUCTS_WITH_USAGE_SUCCESS = 'PRIMARY_SUBSCRIPTION_PRODUCTS_WITH_USAGE_SUCCESS';
export const SET_SUBSCRIPTION_ESTIMATED_TOTAL = 'SET_SUBSCRIPTION_ESTIMATED_TOTAL';

/** Finalize Order Page */
export const UPDATE_SPECIAL_INSTRUCTIONS = 'UPDATE_SPECIAL_INSTRUCTIONS';
export const UPDATE_CHANGES_IN_4_YEARS = 'UPDATE_CHANGES_IN_4_YEARS';
export const UPDATE_PROMO_CODE = 'UPDATE_PROMO_CODE';
export const PLACE_ORDER_SUCCESS = 'PLACE_ORDER_SUCCESS';
export const PLACE_ORDER_ERROR = 'PLACE_ORDER_ERROR';
export const PLACE_ORDER = 'PLACE_ORDER';
export const UPDATE_PAYMENT_INFO = 'UPDATE_PAYMENT_INFO';
export const GET_ESTIMATED_COST = 'GET_ESTIMATED_COST';
export const GET_ESTIMATED_COST_SUCCESS = 'GET_ESTIMATED_COST_SUCCESS';
export const UPDATE_PRODUCT_SETS = 'UPDATE_PRODUCT_SETS';
export const CYBERSOURCE_TOKEN_SUCCESS = 'CYBERSOURCE_TOKEN_SUCCESS';
export const CYBERSOURCE_TOKEN_ERROR = 'CYBERSOURCE_TOKEN_ERROR';
export const VALIDATE_CREDIT_CARD = 'VALIDATE_CREDIT_CARD';
export const LOADING_FINALIZE_ORDER = 'LOADING_FINALIZE_ORDER';
export const LOADED_FINALIZE_ORDER = 'LOADED_FINALIZE_ORDER';
export const LOAD_FINALIZE_ORDER_PAGE = 'LOAD_FINALIZE_ORDER_PAGE';
export const LOAD_FINALIZE_ORDER_ERROR = 'LOAD_FINALIZE_ORDER_ERROR';
export const UPDATE_CARD_CONSENT = 'UPDATE_CARD_CONSENT';
export const UPDATE_PAYMENT_INFO_ERRORS = 'UPDATE_PAYMENT_INFO_ERRORS';
export const CLEAR_PAYMENT_INFO_ERRORS = 'CLEAR_PAYMENT_INFO_ERRORS';
export const RESET_FINALIZE_ORDER_PAGE = 'RESET_FINALIZE_ORDER_PAGE';
export const CLEAR_UPGRADE_FINALIZE_CONTEXT = 'CLEAR_UPGRADE_FINALIZE_CONTEXT';
export const PLACE_ORDER_LOADING = 'PLACE_ORDER_LOADING';
export const PLACE_ORDER_STOP_LOADING = 'PLACE_ORDER_STOP_LOADING';
export const UPDATE_EMAILCC = 'UPDATE_EMAILCC';
export const EXPAND_PANEL = 'EXPAND_PANEL';
export const UPDATE_CLAIM_INFO = 'UPDATE_CLAIM_INFO';
export const UPDATE_PLACE_ORDER_REQUEST = 'UPDATE_PLACE_ORDER_REQUEST';
export const VALIDATOR_FIELDS_SUCCESS = 'VALIDATOR_FIELDS_SUCCESS';
export const UPDATE_CLAIM_INFO_ERRORS = 'UPDATE_CLAIM_INFO_ERRORS';
export const LOAD_UPGRADE_REPORT_FINALIZE_ORDER = 'LOAD_UPGRADE_REPORT_FINALIZE_ORDER';
export const UPGRADE_REPORT_DETAILS_SUCCESS = 'UGRADE_REPORT_DETAILS_SUCCESS';
export const GET_PRODUCT_SETS_AND_ESTIMATED_COST = 'GET_PRODUCT_SETS_AND_ESTIMATED_COST';
export const FETCHING_ESTIMATED_COST = 'FETCHING_ESTIMATED_COST';
export const FETCHED_ESTIMATED_COST = 'FETCHED_ESTIMATED_COST';
export const UPGRADED_REPORT_DETAILS_SUCCESS = 'UPGRADED_REPORT_DETAILS_SUCCESS';
export const UPGRADED_REPORT_DETAILS_LOADING = 'UPGRADED_REPORT_DETAILS_LOADING';
export const UPGRADED_REPORT_DETAILS_FAILURE = 'UPGRADED_REPORT_DETAILS_FAILURE';
export const UPGRADED_REPORT_NOT_FOUND = 'UPGRADED_REPORT_NOT_FOUND';
export const UPDATE_SUBSTITUTION_CUSTOMIZATION_VALUES = 'UPDATE_SUBSTITUTION_CUSTOMIZATION_VALUES';
export const UPDATE_INCLUDE_CUSTOM_COVER = 'UPDATE_INCLUDE_CUSTOM_COVER';

/** Order History Page */
export const LOAD_ORDER_HISTORY_PAGE = 'LOAD_ORDER_HISTORY_PAGE';
export const LOADING_ORDER_HISTORY_REPORTS = 'LOADING_ORDER_HISTORY_REPORTS';
export const LOADED_ORDER_HISTORY_REPORTS = 'LOADED_ORDER_HISTORY_REPORTS';
export const UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER';
export const SET_PAGE_OPTIONS = 'SET_PAGE_OPTIONS';
export const UPDATE_PAGE_OPTIONS = 'UPDATE_PAGE_OPTIONS';
export const ORDER_HISTORY_REPORT_DETAILS_SUCCESS = 'ORDER_HISTORY_REPORT_DETAILS_SUCCESS';
export const ORDER_HISTORY_SUBSCRIPTION_DETAILS_SUCCESS = 'ORDER_HISTORY_SUBSCRIPTION_DETAILS_SUCCESS';
export const ORDER_HISTORY_REPORT_IDS_SUCCESS = 'ORDER_HISTORY_REPORT_IDS_SUCCESS';
export const LOAD_ORDER_HISTORY_ERROR = 'LOAD_ORDER_HISTORY_ERROR';
export const ORDER_HISTORY_REPORT_FILE_TYPES_SUCCESS = 'ORDER_HISTORY_REPORT_FILE_TYPES_SUCCESS';
export const ORDER_HISTORY_PROPERTY_DATA_LOADING = 'ORDER_HISTORY_PROPERTY_DATA_LOADING';
export const ORDER_HISTORY_PROPERTY_DATA_SUCCESS = 'ORDER_HISTORY_PROPERTY_DATA_SUCCESS';
export const ORDER_HISTORY_PROPERTY_DATA_ERROR = 'ORDER_HISTORY_PROPERTY_DATA_ERROR';
export const ORDER_CLOSURE_REASONS_SUCCESS = 'ORDER_CLOSURE_REASONS_SUCCESS';
export const OPEN_CANCEL_ORDER_DIALOG = 'OPEN_CANCEL_ORDER_DIALOG';
export const CLOSE_CANCEL_ORDER_DIALOG = 'CLOSE_CANCEL_ORDER_DIALOG';
export const AVAILABLE_REPORT_ACTIONS_SUCCESS = 'AVAILABLE_REPORT_ACTIONS_SUCCESS';
export const CLEAR_PAGE_DATA = 'CLEAR_PAGE_DATA';
export const UPDATE_SEARCH_TEXT = 'UPDATE_SEARCH_TEXT';
export const CLEAR_REPORTS_DATA = 'CLEAR_REPORTS_DATA';
export const RESET_ORDER_HISTORY_LOAD_ERROR = 'RESET_ORDER_HISTORY_LOAD_ERROR';
export const REPORT_DETAILS_NOT_FOUND = 'REPORT_DETAILS_NOT_FOUND';
export const UPDATE_ORDER_HISTORY_ALERT = 'UPDATE_ORDER_HISTORY_ALERT';
export const ORDER_HISTORY_FILTERS_UPDATE_ORG_NODES_LIST = 'ORDER_HISTORY_FILTERS_UPDATE_ORG_NODES_LIST';
export const ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE = 'ORDER_HISTORY_FILTERS_UPDATE_DATE_RANGE';
export const ORDER_HISTORY_APPLY_FILTERS = 'ORDER_HISTORY_APPLY_FILTERS';
export const ORDER_HISTORY_SET_APPLIED_FILTERS = 'ORDER_HISTORY_SET_APPLIED_FILTERS';
export const ORDER_HISTORY_RESET_FILTERS = 'ORDER_HISTORY_RESET_FILTERS';
export const ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST = 'ORDER_HISTORY_FILTERS_UPDATE_PRODUCTS_LIST';
export const ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST = 'ORDER_HISTORY_FILTERS_UPDATE_STATUS_LIST';

/** Cancel Order Dialog */
export const FETCH_ORDER_CLOSURE_REASONS = 'FETCH_ORDER_CLOSURE_REASONS';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const SET_SELECTED_REASON = 'SET_SELECTED_REASON';
export const SET_OTHER_REASON = 'SET_OTHER_REASON';
export const CANCEL_ORDER_RESPONSE = 'CANCEL_ORDER_RESPONSE';
export const CLOSE_CANCEL_ORDER_ALERT = 'CLOSE_CANCEL_ORDER_ALERT';
export const CANCEL_ORDER_LOADING = 'CANCEL_ORDER_LOADING';
export const CANCEL_ORDER_SELECTION = 'CANCEL_ORDER_SELECTION';

/** Sitemap Page */
export const LOAD_SITEMAP_DATA = 'LOAD_SITEMAP_DATA';
export const LOAD_SITEMAP_DATA_SUCCESS = 'LOAD_SITEMAP_DATA_SUCCESS';
export const LOAD_SITEMAP_DATA_ERROR = 'LOAD_SITEMAP_DATA_ERROR';
export const UPDATE_FOCUSED_POINT_SITEMAP = 'UPDATE_FOCUSED_POINT_SITEMAP';
export const CLEAR_SITEMAP_DATA = 'CLEAR_SITEMAP_DATA';
export const LOADING_SITEMAP_DATA = 'LOADING_SITEMAP_DATA';

/** Report Details Page */
export const LOAD_REPORT_DETAILS_PAGE = 'LOAD_REPORT_DETAILS_PAGE';
export const LOAD_REPORT_DETAILS_PAGE_ERROR = 'LOAD_REPORT_DETAILS_PAGE_ERROR';
export const LOAD_REPORT_DETAILS_PAGE_LOADING = 'LOAD_REPORT_DETAILS_PAGE_LOADING';
export const LOAD_REPORT_DETAILS_PAGE_LOADED = 'LOAD_REPORT_DETAILS_PAGE_LOADED';
export const LOAD_REPORT_ADDRESSES = 'LOAD_REPORT_ADDRESSES';
export const ADD_REPORT_ADDRESS_SUCCESS = 'ADD_REPORT_ADDRESS_SUCCESS';
export const ADD_REPORT_ADDRESS_FAILURE = 'ADD_REPORT_ADDRESS_FAILURE';

/** Order Submitted Page */
export const RESET_ORDER_SUBMITTED = 'RESET_ORDER_SUBMITTED';

/** Address Verification Page */
export const LOAD_ADDRESS_VERIFICATION_PAGE = 'LOAD_ADDRESS_VERIFICATION_PAGE';
export const LOADING_ADDRESS_VERIFICATION_PAGE = 'LOADING_ADDRESS_VERIFICATION_PAGE';
export const LOAD_ADDRESS_VERIFICATION_PAGE_ERROR = 'LOAD_ADDRESS_VERIFICATION_PAGE_ERROR';
export const LOAD_ADDRESS_VERIFICATION_PAGE_SUCCESS = 'LOAD_ADDRESS_VERIFICATION_PAGE_SUCCESS';
export const CLEAR_REPORT_DETAILS_DATA = 'CLEAR_REPORT_DETAILS_DATA';
export const UPDATE_ADDRESS_VERIFICATION_MAP_POINT = 'UPDATE_ADDRESS_VERIFICATION_MAP_POINT';
export const UPDATE_ADDRESS_VERIFICATION_LAT_LONG = 'UPDATE_ADDRESS_VERIFICATION_LAT_LONG';

/** Edit Pitch Page */
export const LOAD_PITCH_EDITOR_PAGE = 'LOAD_PITCH_EDITOR_PAGE';
export const LOADING_PITCH_EDITOR_PAGE = 'LOADING_PITCH_EDITOR_PAGE';
export const LOAD_PITCH_EDITOR_PAGE_SUCCESS = 'LOAD_PITCH_EDITOR_PAGE_SUCCESS';
export const LOAD_PITCH_EDITOR_PAGE_ERROR = 'LOAD_PITCH_EDITOR_PAGE_ERROR';
export const UPDATE_FACET_PITCH = 'UPDATE_FACET_PITCH';
export const UPDATE_ALL_FACETS_PITCH = 'UPDATE_ALL_FACETS_PITCH';
export const CLEAR_PITCH_EDITOR_PAGE = 'CLEAR_PITCH_EDITOR_PAGE';
export const UPDATE_PITCH_STATUS = 'UPDATE_PITCH_STATUS';
export const PITCH_EDITOR_NOT_FOUND = 'PITCH_EDITOR_NOT_FOUND';

/** Reports Change Page */
export const LOAD_REPORTS_CHANGE_PAGE = 'LOAD_REPORTS_CHANGE_PAGE';
export const LOADING_REPORTS_CHANGE_PAGE = 'LOADING_REPORTS_CHANGE_PAGE';
export const LOAD_REPORTS_CHANGE_PAGE_SUCCESS = 'LOAD_REPORTS_CHANGE_PAGE_SUCCESS';
export const LOAD_REPORTS_CHANGE_PAGE_ERROR = 'LOAD_REPORTS_CHANGE_PAGE_ERROR';
export const REPORTS_CHANGE_NOT_FOUND = 'REPORTS_CHANGE_NOT_FOUND';
export const REPORTS_CHANGE_BAD_REQUEST = 'REPORTS_CHANGE_BAD_REQUEST';

/** Dashboard Page */
export const LOAD_DASHBOARD_PAGE = 'LOAD_DASHBOARD_PAGE';
export const LOAD_RECENT_ORDERS = 'LOAD_RECENT_ORDERS';
export const LOAD_ACCOUNT_SUMMARY = 'LOAD_ACCOUNT_SUMMARY';
export const ACCOUNT_SUMMARY_DETAILS = 'ACCOUNT_SUMMARY_DETAILS';
export const ACCOUNT_SUMMARY_SUCCESS = 'ACCOUNT_SUMMARY_SUCCESS';
export const ACCOUNT_SUMMARY_ERROR = 'ACCOUNT_SUMMARY_ERROR';
export const LOADING_ACCOUNT_SUMMARY = 'LOADING_ACCOUNT_SUMMARY';
export const LOAD_SUBSCRIPTION_DASHBOARD = 'LOAD_SUBSCRIPTION_DASHBOARD';

/** Order Preference Page */
export const LOAD_ORDER_PREFERENCE_PAGE = 'LOAD_ORDER_PREFERENCE_PAGE';
export const UPDATE_ORDER_PREFERENCES_INPUT_FIELD_VALUE = 'UPDATE_ORDER_PREFERENCES_INPUT_FIELD_VALUE';
export const SAVE_ORDER_PREFERENCES = 'SAVE_ORDER_PREFERENCES';
export const SAVE_ORDER_PREFERENCES_LOADING = 'SAVE_ORDER_PREFERENCES_LOADING';
export const SAVE_ORDER_PREFERENCES_SUCCESS = 'SAVE_ORDER_PREFERENCES_SUCCESS';
export const SAVE_ORDER_PREFERENCES_ERROR = 'SAVE_ORDER_PREFERENCES_ERROR';
export const CLOSE_ORDER_PREFERENCES_ALERT = 'CLOSE_ORDER_PREFERENCES_ALERT';
export const CANCEL_ORDER_PREFERENCES_CHANGES = 'CANCEL_ORDER_PREFERENCES_CHANGES';
export const UPDATE_ORDER_PREFERENCES_INPUT_FIELD_PROPERTY = 'UPDATE_ORDER_PREFERENCES_INPUT_FIELD_PROPERTY';
export const INIT_COVER_PAGE_FIELDS = 'INIT_COVER_PAGE_FIELDS';

/** Account Deletion Page */
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const DELETE_ACCOUNT_SUCCESS = 'DELETE_ACCOUNT_SUCCESS';
export const DELETE_ACCOUNT_FAILURE = 'DELETE_ACCOUNT_FAILURE';
export const DELETING_ACCOUNT = 'DELETING_ACCOUNT';
export const DELETE_ACCOUNT_CLEAR_FAILURE_ERROR = 'DELETE_ACCOUNT_CLEAR_FAILURE_ERROR';

/** Billing Information Page */
export const LOAD_BILLING_INFO = 'LOAD_BILLING_INFO';
// #genai Phase 2 — hydrate ONLY userData.billingInformation (billPayerId / initParameters) for the
// dedicated Add-Card / Add-ACH deep-link routes, WITHOUT resetting or pre-filling the empty add form.
export const LOAD_BILLING_ACCOUNT_CONTEXT = 'LOAD_BILLING_ACCOUNT_CONTEXT';
export const LOAD_BILLING_INFO_START = 'LOAD_BILLING_INFO_START';
export const LOAD_BILLING_INFO_COMPLETE = 'LOAD_BILLING_INFO_COMPLETE';
export const LOAD_BILLING_INFO_ERROR = 'LOAD_BILLING_INFO_ERROR';
export const BILLING_INFO_UPDATE_PAYMENT_INFO = 'BILLING_INFO_UPDATE_PAYMENT_INFO';
export const BILLING_INFO_UPDATE_CARD_CONSENT = 'BILLING_INFO_UPDATE_CARD_CONSENT';
export const BILLING_INFO_UPDATE_ACH_CONSENT = 'BILLING_INFO_UPDATE_ACH_CONSENT'; // #genai
export const BILLING_INFO_LOAD_ACH_INFO = 'BILLING_INFO_LOAD_ACH_INFO'; // #genai
export const BILLING_INFO_UPDATE_ACH_DEFAULT = 'BILLING_INFO_UPDATE_ACH_DEFAULT'; // #genai
export const BILLING_INFO_SET_EDITING_ACH = 'BILLING_INFO_SET_EDITING_ACH'; // #genai
export const BILLING_INFO_UPDATE_CARD_PAYMENT_INFO = 'BILLING_INFO_UPDATE_CARD_PAYMENT_INFO'; // #genai
export const BILLING_INFO_UPDATE_ACH_PAYMENT_INFO = 'BILLING_INFO_UPDATE_ACH_PAYMENT_INFO'; // #genai
export const BILLING_INFO_SET_SELECTED_PAYMENT_METHOD = 'BILLING_INFO_SET_SELECTED_PAYMENT_METHOD'; // #genai
export const BILLING_INFO_OPEN_SAVE_DISCLAIMER = 'BILLING_INFO_OPEN_SAVE_DISCLAIMER'; // #genai
export const BILLING_INFO_CLOSE_SAVE_DISCLAIMER = 'BILLING_INFO_CLOSE_SAVE_DISCLAIMER'; // #genai
export const BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS = 'BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS'; // #genai
export const BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS = 'BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS'; // #genai
export const BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS_FOR_BANNER = 'BILLING_INFO_UPDATE_CARD_PAYMENT_INFO_ERRORS_FOR_BANNER'; // #genai
export const BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS_FOR_BANNER = 'BILLING_INFO_UPDATE_ACH_PAYMENT_INFO_ERRORS_FOR_BANNER'; // #genai
export const BILLING_INFO_LOAD_ADDRESS_INFO = 'BILLING_INFO_LOAD_ADDRESS_INFO';
export const BILLING_INFO_UPDATE_ADDRESS_INFO = 'BILLING_INFO_UPDATE_ADDRESS_INFO';
export const BILLING_INFO_UPDATE_ADDRESS_INFO_FIELDS = 'BILLING_INFO_UPDATE_ADDRESS_INFO_FIELDS';
export const BILLING_INFO_UPDATE_ADDRESS_INFO_ERRORS = 'BILLING_INFO_UPDATE_ADDRESS_INFO_ERRORS';
export const BILLING_INFO_SHOW_ADDRESS_VALIDATION_ERRORS = 'BILLING_INFO_SHOW_ADDRESS_VALIDATION_ERRORS';
export const BILLING_INFO__RESET_VALIDATION_ERRORS = 'BILLING_INFO__RESET_VALIDATION_ERRORS';
export const BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS = 'BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS';
export const BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS_FOR_BANNER = 'BILLING_INFO_UPDATE_PAYMENT_INFO_ERRORS_FOR_BANNER';
export const BILLING_INFO_RESET_PAGE = 'BILLING_INFO_RESET_PAGE';
// #genai Phase 2: clears card/ACH/address form slices so /add-card and /add-ach always open fresh.
export const BILLING_INFO_RESET_ADD_PAYMENT_FORM = 'BILLING_INFO_RESET_ADD_PAYMENT_FORM';
export const BILLING_INFO_SUBMIT = 'BILLING_INFO_SUBMIT';
export const BILLING_INFO_SUBMIT_RESET = 'BILLING_INFO_SUBMIT_RESET';
export const BILLING_INFO_SUBMIT_VALIDATION_ERROR = 'BILLING_INFO_SUBMIT_VALIDATION_ERROR';
export const PAYMENT_TOKEN_RESET = 'PAYMENT_TOKEN_RESET';
export const PAYMENT_TOKEN_ERROR = 'PAYMENT_TOKEN_ERROR';
export const PAYMENT_TOKEN_SUCCESS = 'PAYMENT_TOKEN_SUCCESS';
export const BILLING_INFO_SUBMIT_START = 'BILLING_INFO_SUBMIT_START';
export const BILLING_INFO_SUBMIT_COMPLETE = 'BILLING_INFO_SUBMIT_COMPLETE';
export const BILLING_INFO_SUBMIT_ERROR = 'BILLING_INFO_SUBMIT_ERROR';

/** Phase 2 — unified saved payment methods list (ENABLE_MULTI_PAYMENT_METHODS) */
export const LOAD_PAYMENT_METHODS = 'LOAD_PAYMENT_METHODS'; // #genai
export const LOAD_PAYMENT_METHODS_START = 'LOAD_PAYMENT_METHODS_START'; // #genai
export const LOAD_PAYMENT_METHODS_SUCCESS = 'LOAD_PAYMENT_METHODS_SUCCESS'; // #genai
export const LOAD_PAYMENT_METHODS_ERROR = 'LOAD_PAYMENT_METHODS_ERROR'; // #genai
export const SET_PAYMENT_METHOD_DEFAULT = 'SET_PAYMENT_METHOD_DEFAULT'; // #genai
export const SET_PAYMENT_METHOD_DEFAULT_SUCCESS = 'SET_PAYMENT_METHOD_DEFAULT_SUCCESS'; // #genai
export const SET_PAYMENT_METHOD_DEFAULT_ERROR = 'SET_PAYMENT_METHOD_DEFAULT_ERROR'; // #genai
export const REMOVE_PAYMENT_METHOD = 'REMOVE_PAYMENT_METHOD'; // #genai
export const REMOVE_PAYMENT_METHOD_SUCCESS = 'REMOVE_PAYMENT_METHOD_SUCCESS'; // #genai
export const REMOVE_PAYMENT_METHOD_ERROR = 'REMOVE_PAYMENT_METHOD_ERROR'; // #genai
export const REMOVE_PAYMENT_METHOD_BLOCKED_DEFAULT = 'REMOVE_PAYMENT_METHOD_BLOCKED_DEFAULT'; // #genai
export const RESET_PAYMENT_METHODS_ACTION_ERROR = 'RESET_PAYMENT_METHODS_ACTION_ERROR'; // #genai
// #genai Phase 2 — cross-route success banner ("Payment method added ... ending in <suffix>").
// Set by the Add-ACH / Add-Card pages on successful save; consumed once + cleared by the
// SavedPaymentMethods list on the /billing-information page. Redux-based (not history state) so
// it survives StrictMode double-effects, parent conditional branches, and any intermediate
// unmount/remount of SavedPaymentMethods between the redirect and the list finishing its load.
export const SET_RECENTLY_ADDED_PAYMENT_METHOD = 'SET_RECENTLY_ADDED_PAYMENT_METHOD';
export const CLEAR_RECENTLY_ADDED_PAYMENT_METHOD = 'CLEAR_RECENTLY_ADDED_PAYMENT_METHOD';

/** Contact Information Page */
export const LOAD_CONTACT_INFO = 'LOAD_CONTACT_INFO';
export const LOAD_CONTACT_INFO_START = 'LOAD_CONTACT_INFO_START';
export const LOAD_CONTACT_INFO_SUCCESS = 'LOAD_CONTACT_INFO_SUCCESS';
export const LOAD_CONTACT_INFO_ERROR = 'LOAD_CONTACT_INFO_ERROR';
export const CONTACT_INFO_LOAD_ADDRESS_INFO = 'CONTACT_INFO_LOAD_ADDRESS_INFO';
export const CONTACT_INFO_LOAD_COMPANY_LOGO = 'CONTACT_INFO_LOAD_LOGO';
export const CONTACT_INFO_UPDATE_ADDRESS_INFO = 'CONTACT_INFO_UPDATE_ADDRESS_INFO';
export const CONTACT_INFO_UPDATE_ADDRESS_INFO_FIELDS = 'CONTACT_INFO_UPDATE_ADDRESS_INFO_FIELDS';
export const CONTACT_INFO_SHOW_ADDRESS_VALIDATION_ERRORS = 'CONTACT_INFO_SHOW_ADDRESS_VALIDATION_ERRORS';
export const CONTACT_INFO_RESET_ADDRESS_VALIDATION_ERRORS = 'CONTACT_INFO_RESET_ADDRESS_VALIDATION_ERRORS';
export const CONTACT_INFO_RESET_PAGE = 'CONTACT_INFO_RESET_PAGE';
export const CONTACT_INFO_LOAD_COMPANY_LOGO_ERROR = 'CONTACT_INFO_LOAD_COMPANY_LOGO_ERROR';
export const CONTACT_INFO_SUBMIT = 'CONTACT_INFO_SUBMIT';
export const CONTACT_INFO_SUBMIT_START = 'CONTACT_INFO_SUBMIT_START';
export const CONTACT_INFO_SUBMIT_VALIDATION_ERROR = 'CONTACT_INFO_SUBMIT_VALIDATION_ERROR';
export const CONTACT_INFO_RESET_VALIDATION_ERROR = 'CONTACT_INFO_RESET_VALIDATION_ERROR';
export const CONTACT_INFO_SUBMIT_COMPLETE = 'CONTACT_INFO_SUBMIT_COMPLETE';
export const CONTACT_INFO_SUBMIT_ERROR = 'CONTACT_INFO_SUBMIT_ERROR';
export const CONTACT_INFO_SUBMIT_RESET = 'CONTACT_INFO_SUBMIT_RESET';

/** Upload Information Page */
export const LOAD_UPLOAD_INFORMATION_PAGE = 'LOAD_UPLOAD_INFORMATION_PAGE';
export const LOADING_UPLOAD_INFORMATION_PAGE = 'LOADING_UPLOAD_INFORMATION_PAGE';
export const LOAD_UPLOAD_INFORMATION_PAGE_SUCCESS = 'LOADING_UPLOAD_INFORMATION_PAGE_SUCCESS';
export const LOAD_UPLOAD_INFORMATION_PAGE_ERROR = 'LOAD_UPLOAD_INFORMATION_PAGE_ERROR';
export const UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE = 'UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE';
export const UPLOAD_INFORMATION_UPLOADING_BLUEPRINT_FILE = 'UPLOAD_INFORMATION_UPLOADING_BLUEPRINT_FILE';
export const UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_SUCCESS = 'UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_SUCCESS';
export const UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_ERROR = 'UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE_ERROR';
export const UPLOAD_INFORMATION_UPDATE_INSTRUCTIONS = 'UPLOAD_INFORMATION_UPDATE_INSTRUCTIONS';
export const CLEAR_UPLOAD_INFORMATION_DATA = 'CLEAR_UPLOAD_INFORMATION_DATA';
export const UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_ERROR = 'UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_ERROR';
export const UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_SUCCESS = 'UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_SAVE_SUCCESS';

/** Check Image Coverage */
export const CHECK_IMAGE_COVERAGE = 'CHECK_IMAGE_COVERAGE';
export const CHECK_IMAGE_COVERAGE_START = 'CHECK_IMAGE_COVERAGE_START';
export const CHECK_IMAGE_COVERAGE_ERROR = 'CHECK_IMAGE_COVERAGE_ERROR';
export const CHECK_IMAGE_COVERAGE_SUCCESS = 'CHECK_IMAGE_COVERAGE_SUCCESS';
export const CHECK_IMAGE_COVERAGE_RESET = 'CHECK_IMAGE_COVERAGE_RESET';

/** Validate SRS Customer */
export const VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER = 'VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER';
export const VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_START = 'VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_START';
export const VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_SUCCESS = 'VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_SUCCESS';
export const VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_ERROR = 'VALIDATE_SRS_BILLING_AFFILIATED_CUSTOMER_ERROR';
export const UPDATE_SRS_BRANCH_EMPLOYEE_INFO = 'UPDATE_SRS_BRANCH_EMPLOYEE_INFO';
export const UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO = 'UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO';
export const UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO_FOR_DISPLAY = 'UPDATE_SRS_BRANCH_EMPLOYEE_ERROR_INFO_FOR_DISPLAY';
export const VALIDATE_SRS_BRANCH_EMPLOYEE = 'VALIDATE_SRS_BRANCH_EMPLOYEE';
export const VALIDATE_SRS_BRANCH_EMPLOYEE_RESET = 'VALIDATE_SRS_BRANCH_EMPLOYEE_RESET';
export const VALIDATE_SRS_BRANCH_EMPLOYEE_START = 'VALIDATE_SRS_BRANCH_EMPLOYEE_START';
export const VALIDATE_SRS_BRANCH_EMPLOYEE_SUCCESS = 'VALIDATE_SRS_BRANCH_EMPLOYEE_SUCCESS';
export const VALIDATE_SRS_BRANCH_EMPLOYEE_ERROR = 'VALIDATE_SRS_BRANCH_EMPLOYEE_ERROR';
export const VALIDATE_SRS_BRANCH_EMPLOYEE_HIDE_SUCCESS_BANNER = 'VALIDATE_SRS_BRANCH_EMPLOYEE_HIDE_SUCCESS_BANNER';
export const UPDATE_SRS_BRANCH_EMPLOYEE_EMPTY_SUBMISSION = 'UPDATE_SRS_BRANCH_EMPLOYEE_EMPTY_SUBMISSION';
export const VALIDATE_SRS_BRANCH_EMPLOYEE_INFO_RESET = 'VALIDATE_SRS_BRANCH_EMPLOYEE_INFO_RESET';
/** Notification Bar  */
export const NOTIFICATION_START = 'NOTIFICATION_START';
export const NOTIFICATION_SUCCESS = 'NOTIFICATION_SUCCESS';
export const NOTIFICATION_ERROR = 'NOTIFICATION_ERROR';
export const NOTIFICATION_CLOSE = 'NOTIFICATION_CLOSE';

/** Text Alert Settings */
export const LOAD_TEXT_ALERT_SETTINGS_PAGE = 'LOAD_TEXT_ALERT_SETTINGS_PAGE';
export const TEXT_ALERT_SETTINGS_LOADING = 'TEXT_ALERT_SETTINGS_LOADING';
export const TEXT_ALERT_SETTINGS_SUCCESS = 'TEXT_ALERT_SETTINGS_SUCCESS';
export const TEXT_ALERT_SETTINGS_ERROR = 'TEXT_ALERT_SETTINGS_ERROR';
export const UPDATE_TEXT_ALERT_PHONE_NUMBER_DETAILS = 'UPDATE_TEXT_ALERT_PHONE_NUMBER_DETAILS';
export const UPDATE_TEXT_ALERT_CONDITIONS = 'UPDATE_TEXT_ALERT_CONDITIONS';
export const UPDATE_TEXT_ALERT_DELIVERY_STATUS = 'UPDATE_TEXT_ALERT_DELIVERY_STATUS';
export const RESET_TEXT_ALERT_PREFERENCES = 'RESET_TEXT_ALERT_PREFERENCES';
export const SAVE_TEXT_ALERT_SETTINGS_LOADING = 'SAVE_TEXT_ALERT_SETTINGS_LOADING';
export const SAVE_TEXT_ALERT_SETTINGS_SUCCESS = 'SAVE_TEXT_ALERT_SETTINGS_SUCCESS';
export const SAVE_TEXT_ALERT_SETTINGS_ERROR = 'SAVE_TEXT_ALERT_SETTINGS_ERROR';
export const LOAD_SAVE_TEXT_ALERT_PREFERENCES = 'LOAD_SAVE_TEXT_ALERT_PREFERENCES';
export const CLOSE_TEXT_ALERT_PREFERENCES_BANNER = 'CLOSE_TEXT_ALERT_PREFERENCES_BANNER';

/** Manage Payment Options */
export const LOAD_MANAGE_PAYMENT_OPTIONS_PAGE = 'LOAD_MANAGE_PAYMENT_OPTIONS_PAGE';
export const MANAGE_PAYMENT_OPTIONS_LOADING = 'MANAGE_PAYMENT_OPTIONS_LOADING';
export const MANAGE_PAYMENT_OPTIONS_SUCCESS = 'MANAGE_PAYMENT_OPTIONS_SUCCESS';
export const MANAGE_PAYMENT_OPTIONS_ERROR = 'MANAGE_PAYMENT_OPTIONS_ERROR';
export const MANAGE_PAYMENT_OPTIONS_AMOUNT_UPDATES = 'MANAGE_PAYMENT_OPTIONS_AMOUNT_UPDATES';
export const MANAGE_PAYMENT_OPTIONS_SUSPEND_MONTHLY_PREPAY = 'MANAGE_PAYMENT_OPTIONS_SUSPEND_MONTHLY_PREPAY';
export const SAVE_SUSPEND_PREPAY_OPTIONS = 'SAVE_SUSPEND_PREPAY_OPTIONS';
export const SAVE_SUSPEND_PREPAY_OPTIONS_LOADING = 'SAVE_SUSPEND_PREPAY_OPTIONS_LOADING';
export const SAVE_SUSPEND_PREPAY_OPTIONS_SUCCESS = 'SAVE_SUSPEND_PREPAY_OPTIONS_SUCCESS';
export const SAVE_SUSPEND_PREPAY_OPTIONS_ERROR = 'SAVE_SUSPEND_PREPAY_OPTIONS_ERROR';
export const CLOSE_SUSPEND_PREPAY_OPTIONS_BANNER = 'CLOSE_SUSPEND_PREPAY_OPTIONS_BANNER';
export const UPDATE_MANAGE_PAYMENTS_CARD_DETAILS = 'UPDATE_MANAGE_PAYMENTS_CARD_DETAILS';
export const RESET_MANAGE_PAYMENT_ACCOUNT_UPDATE_DETAILS = 'RESET_MANAGE_PAYMENT_ACCOUNT_UPDATE_DETAILS';
export const UPDATE_MANAGE_PAYMENTS_CARD_CONSENT = 'UPDATE_MANAGE_PAYMENTS_CARD_CONSENT';
export const UPDATE_MANAGE_PAYMENT_PURCHASE_ORDER_VALUE = 'UPDATE_MANAGE_PAYMENT_PURCHASE_ORDER_VALUE';
export const MANAGE_PAYMENT_OPTIONS_AMOUNT_UPDATES_ERROR = 'MANAGE_PAYMENT_OPTIONS_AMOUNT_UPDATES_ERROR';
export const UPDATE_ACCOUNT_PAYMENT_OPTIONS = 'UPDATE_ACCOUNT_PAYMENT_OPTIONS';
export const UPDATE_ACCOUNT_PAYMENT_OPTIONS_LOADING = 'UPDATE_ACCOUNT_PAYMENT_OPTIONS_LOADING';
export const UPDATE_ACCOUNT_PAYMENT_OPTIONS_SUCCESS = 'UPDATE_ACCOUNT_PAYMENT_OPTIONS_SUCCESS';
export const UPDATE_ACCOUNT_PAYMENT_OPTIONS_ERROR = 'UPDATE_ACCOUNT_PAYMENT_OPTIONS_ERROR';
export const UPDATE_MANAGE_PAYMENTS_PAYMENT_INFO_ERRORS = 'UPDATE_MANAGE_PAYMENTS_PAYMENT_INFO_ERRORS';
export const RESET_UPDATE_ACCOUNT_SUCCESS_RESPONSE_DETAILS = 'RESET_UPDATE_ACCOUNT_SUCCESS_RESPONSE_DETAILS';

/** Analytics Dashboard */
export const FETCH_REPORT_ANALYTICS = 'FETCH_REPORT_ANALYTICS';
export const FETCH_REPORT_ANALYTICS_LOADING = 'FETCH_REPORT_ANALYTICS_LOADING';
export const FETCH_REPORT_ANALYTICS_SUCCESS = 'FETCH_REPORT_ANALYTICS_SUCCESS';
export const FETCH_REPORT_ANALYTICS_ERROR = 'FETCH_REPORT_ANALYTICS_ERROR';
export const UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS = 'UPDATE_REPORT_ANALYTICS_PAGE_OPTIONS';
export const SET_REPORT_ANALYTICS_PAGE_OPTIONS = 'SET_REPORT_ANALYTICS_PAGE_OPTIONS';
export const SET_REPORT_ANALYTICS_FILTERS = 'SET_REPORT_ANALYTICS_FILTERS';
export const APPLY_REPORT_ANALYTICS_FILTERS = 'APPLY_REPORT_ANALYTICS_FILTERS';
export const APPLY_REPORT_ANALYTICS_FILTERS_FROM_URL = 'APPLY_REPORT_ANALYTICS_FILTERS_FROM_URL';
export const RESET_REPORT_ANALYTICS_FILTERS = 'RESET_REPORT_ANALYTICS_FILTERS';
export const SET_REPORT_ANALYTICS_SEARCH_TEXT = 'SET_REPORT_ANALYTICS_SEARCH_TEXT';
export const SET_REPORT_ANALYTICS_DATE_RANGE = 'SET_REPORT_ANALYTICS_DATE_RANGE';
export const UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT = 'UPDATE_REPORT_ANALYTICS_SELECTED_PRODUCT';
export const ADD_REPORT_ANALYTICS_PRODUCTS_LIST = 'ADD_REPORT_ANALYTICS_PRODUCTS_LIST';
export const SET_ANALYTICS_REPORTS_COUNT = 'SET_ANALYTICS_REPORTS_COUNT';
export const CLEAR_REPORT_ANALYTICS = 'CLEAR_REPORT_ANALYTICS';

/** Statefarm Dashboard */
export const FETCH_STATEFARM_DASHBOARD_SUCCESS = 'FETCH_STATEFARM_DASHBOARD_SUCCESS';
export const FETCH_STATEFARM_DASHBOARD_LOADING = 'FETCH_STATEFARM_DASHBOARD_LOADING';
export const FETCH_STATEFARM_DASHBOARD_ERROR = 'FETCH_STATEFARM_DASHBOARD_ERROR';
export const FETCH_STATEFARM_DASHBOARD = 'FETCH_STATEFARM_DASHBOARD';
export const UPDATE_LOCAL_STATEFARM_FILTER = 'UPDATE_LOCAL_STATEFARM_FILTER';
export const UPDATE_APPLIED_STATEFARM_FILTER = 'UPDATE_APPLIED_STATEFARM_FILTER';
export const RESET_STATEFARM_FILTER = 'RESET_STATEFARM_FILTER';

/** Consumption */
export const LOAD_CONSUMPTION_DATA = 'LOAD_CONSUMPTION_DATA';
export const LOAD_CONSUMPTION_DATA_LOADING = 'LOAD_CONSUMPTION_DATA_LOADING';
export const LOAD_CONSUMPTION_DATA_SUCCESS = 'LOAD_CONSUMPTION_DATA_SUCCESS';
export const LOAD_CONSUMPTION_DATA_ERROR = 'LOAD_CONSUMPTION_DATA_ERROR';

/** Subscriptions */
export const GET_SUBSCRIPTIONS = 'GET_SUBSCRIPTIONS';
export const GET_SUBSCRIPTIONS_LOADING = 'GET_SUBSCRIPTIONS_LOADING';
export const GET_SUBSCRIPTIONS_SUCCESS = 'GET_SUBSCRIPTIONS_SUCCESS';
export const GET_SUBSCRIPTIONS_ERROR = 'GET_SUBSCRIPTIONS_ERROR';
